<template>
    <div class="columns is-multiline p-4">
        <div class="column is-6">
            <h1 class="is-size-5">REPORTE BASE</h1>
        </div>
        <div class="column is-6 is-inline-flex is-justify-content-center">
            <div class="field mr-3">
                <div class="control">
                    <label class="mr-2"
                        >Recarga en {{ reloadCountdown }} segundos</label
                    >
                    <button
                        class="button is-primary"
                        @click="reload"
                        :disabled="isLoading"
                    >
                        <Icon family="fal" name="fa-sync" />
                    </button>
                </div>
            </div>
            <div class="field has-addons">
                <div class="control ml-4">
                    <input
                        type="text"
                        class="input is-radiusless"
                        v-model="filters.search"
                        @keydown.enter="refreshFilters"
                    />
                </div>
                <div class="control">
                    <button
                        class="button is-primary is-radiusless"
                        @click="refreshFilters"
                    >
                        <Icon family="fal" name="fa-search" />
                    </button>
                </div>
            </div>
        </div>
        <div class="column is-12 is-inline-flex" v-if="isLoading">
            <Loading />
        </div>
        <div class="column is-12 is-inline-flex" v-else>
            <table class="table is-striped is-hoverable is-fullwidth">
                <thead class="is-size-7">
                    <tr>
                        <th>Fecha y Hora</th>
                        <th>Estado</th>
                        <th>Operador</th>
                        <th>Email Operador</th>
                        <th>Cédula</th>
                        <th>Nombre</th>
                        <th>Email</th>
                        <th>Trámite</th>
                        <th>Tiempo de Espera</th>
                        <th>Tiempo en llamada</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(row, idx) in items">
                        <tr :key="idx">
                            <td>{{ row.creationDate }}</td>
                            <td>{{ row.status }}</td>
                            <td>{{ row.operatorName }}</td>
                            <td>{{ row.operatorEmail }}</td>
                            <td>{{ row.userCedula }}</td>
                            <td>{{ row.userName }}</td>
                            <td>{{ row.userEmail }}</td>
                            <td>{{ row.skill }}</td>
                            <td>{{ row.waitingTime }}</td>
                            <td>{{ row.onCallTime }}</td>
                        </tr>
                    </template>
                    <tr v-if="totalPages === 0">
                        <td align="center" colspan="12">No hay registros...</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div
            v-if="totalPages > 1"
            class="column is-12 is-inline-flex is-justify-content-flex-end"
        >
            <nav class="pagination" role="navigation">
                <a
                    class="pagination-previous"
                    v-if="currentPage > 1"
                    v-on:click="prev()"
                    >Anterior</a
                >
                <a
                    class="pagination-previous"
                    v-if="currentPage < totalPages"
                    v-on:click="next()"
                    >Siguiente</a
                >

                <ul class="pagination-list">
                    <li v-if="currentPage > 2">
                        <a class="pagination-link" @click="goto(1)">1</a>
                    </li>

                    <li v-if="currentPage > 3">
                        <span class="pagination-ellipsis">&hellip;</span>
                    </li>
                    <li v-if="currentPage > 1">
                        <a
                            class="pagination-link"
                            v-on:click="goto(currentPage - 1)"
                            >{{ currentPage - 1 }}</a
                        >
                    </li>
                    <li>
                        <a
                            class="pagination-link is-current"
                            v-on:click="goto(currentPage)"
                            >{{ currentPage }}</a
                        >
                    </li>
                    <li v-if="totalPages > currentPage">
                        <a
                            class="pagination-link"
                            v-on:click="goto(currentPage + 1)"
                            >{{ currentPage + 1 }}</a
                        >
                    </li>
                    <li v-if="totalPages - currentPage > 2">
                        <span class="pagination-ellipsis">&hellip;</span>
                    </li>

                    <li v-if="totalPages - currentPage > 1">
                        <a
                            class="pagination-link"
                            v-on:click="goto(totalPages)"
                            >{{ this.totalPages }}</a
                        >
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { RepositoryFactory } from "@/services/api";
import Loading from "@/components/Loading.vue";

export default {
    name: "base-report",
    components: {
        Loading,
    },
    props: {
        signalRSocket: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoading: true,
            items: [],
            currentPage: 1,
            totalPages: 0,
            filters: {
                page: 1,
                take: 10,
                search: "",
            },

            reloadCountdown: 60,
            reloadTimer: null,
        };
    },
    mounted() {
        this.getItems();
    },
    beforeDestroy() {
        this.stopTimer();
    },
    methods: {
        startTimer() {
            this.reloadTimer = setInterval(() => {
                this.reloadCountdown--;
                if (!this.isLoading && this.reloadCountdown === 0) {
                    this.reloadCountdown = 60;
                    this.getItems();
                } else if (this.reloadCountdown <= 0) {
                    this.reloadCountdown = 60;
                }
            }, 1000);
        },
        stopTimer() {
            this.reloadCountdown = 60;
            clearInterval(this.reloadTimer);
        },
        userJoined() {
            this.getItems();
        },
        userLeaved() {
            this.getItems();
        },
        reload() {
            this.getItems();
        },
        async getItems() {
            this.stopTimer();
            this.isLoading = true;
            try {
                var response =
                    await RepositoryFactory.reports.getTodayReportBase(
                        this.filters
                    );
                let items = response.data.items;
                items = this.parseItems(items);
                this.items = items;
                this.totalPages = response.data.pages;
            } catch (error) {
                window.console.log(error);
            }
            this.isLoading = false;
            this.startTimer();
        },
        parseItems(items) {
            for (const item of items) {
                item.status = this.getStatus(item.status);
                item.creationDate = this.formatDate(item.creationDate);
                item.waitingTime = this.parseTime(item.waitingTime);
                item.onCallTime = this.parseTime(item.onCallTime);
            }
            return items;
        },
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY hh:mm A");
        },
        parseTime(time) {
            if (time === null) {
                return "-";
            }
            return time.split(".")[0];
        },
        getStatus(status) {
            switch (status) {
                case 0:
                    return "En cola";
                case 1:
                    return "Atendida";
                case 2:
                    return "Abandonada";
            }
            return "";
        },
        refreshFilters() {
            this.currentPage = 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        goto(page) {
            this.currentPage = page;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        prev() {
            this.currentPage = this.currentPage - 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        next() {
            this.currentPage = this.currentPage + 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
    },
};
</script>